import { struct } from 'io-ts/Decoder';

import { ParentId } from '../../../file/ParentId';

export const Params = struct({
	parentId: ParentId,
});
